import 'jquery';
import 'select2';
import 'daterangepicker';

import Quill from 'quill'
import QuillTheme from './js/QuillTheme'
Quill.register('themes/quantum', QuillTheme, true)

import TOC from './js/TOC';
import Breadcrumb from './js/Breadcrumb';
import Currency from './js/Currency';
import InputColorHex from './js/InputColorHex';
import InputNumber from './js/InputNumber';
import Select2fn from './js/Select2fn';
import moment from 'moment';

export default {
  TOC,
  Breadcrumb,
  Currency,
  InputColorHex,
  InputNumber,
  Select2fn,
  moment,
  Quill,
  QuillTheme
}
